import script from "./OSeletorSemanal.vue?vue&type=script&lang=ts&setup=true"
export * from "./OSeletorSemanal.vue?vue&type=script&lang=ts&setup=true"

import "./OSeletorSemanal.vue?vue&type=style&index=0&id=23bd96ca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23bd96ca"]])

export default __exports__